import React from "react";
import { Box, Pagination, useMediaQuery, useTheme } from "@mui/material";

import { relativeLuminance, withAlpha } from "../../utils/gradients";

/* Paginador premium del perfil público: píldora flotante blanca con ítems
 * circulares; la página activa usa el degradado de marca del nutriólogo. */
const BrandPagination = ({
  count,
  page,
  onChange,
  gradient,
  accentColor,
  textColor,
}) => {
  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down("sm"));

  if (!count || count <= 1) return null;

  const selectedText =
    textColor ||
    (relativeLuminance(accentColor) > 0.55 ? "#0f172a" : "#ffffff");
  const selectedGradient =
    gradient ||
    `linear-gradient(135deg, ${accentColor} 0%, ${accentColor} 100%)`;

  return (
    <Box
      sx={{
        display: "inline-flex",
        background: "#fff",
        borderRadius: 999,
        px: { xs: 0.75, sm: 1.25 },
        py: 0.75,
        border: "1px solid rgba(15,23,42,0.06)",
        boxShadow: "0 14px 34px rgba(15,23,42,0.10)",
      }}
    >
      <Pagination
        count={count}
        page={page}
        onChange={onChange}
        siblingCount={compact ? 0 : 1}
        boundaryCount={1}
        sx={{
          "& .MuiPaginationItem-root": {
            borderRadius: 999,
            fontWeight: 700,
            minWidth: { xs: 34, sm: 40 },
            height: { xs: 34, sm: 40 },
            mx: { xs: 0.2, sm: 0.5 },
            color: "#475569",
            transition: "all 200ms ease",
            "&:hover": {
              backgroundColor: withAlpha(accentColor, 0.08),
              color: accentColor,
              transform: "translateY(-1px)",
            },
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundImage: selectedGradient,
            color: selectedText,
            textShadow:
              selectedText === "#ffffff"
                ? "0 1px 8px rgba(2,6,23,0.35)"
                : "none",
            boxShadow: `0 10px 24px ${withAlpha(accentColor, 0.35)}`,
            "&:hover": {
              backgroundImage: selectedGradient,
              color: selectedText,
              transform: "none",
            },
          },
          "& .MuiPaginationItem-previousNext": {
            border: "1px solid rgba(15,23,42,0.10)",
            color: "#334155",
            "&:hover": {
              borderColor: withAlpha(accentColor, 0.5),
              color: accentColor,
              backgroundColor: withAlpha(accentColor, 0.06),
            },
            "&.Mui-disabled": {
              opacity: 0.35,
            },
          },
          "& .MuiPaginationItem-ellipsis": {
            color: "#94a3b8",
            fontWeight: 700,
            display: "grid",
            placeItems: "center",
          },
        }}
      />
    </Box>
  );
};

export default BrandPagination;
